import { render } from "./VersionAlertModal.vue?vue&type=template&id=eba98776"
import script from "./VersionAlertModal.vue?vue&type=script&lang=js"
export * from "./VersionAlertModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__